import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

const WEB_APP_URL =
  "https://script.google.com/macros/s/AKfycbwjALm03d7vdWLLOexAK9uSffZhofMRdGczvZVEOepHcDH1RSBhZf13Z58wqt0kGcJc-g/exec";
//   https://script.google.com/macros/s/AKfycbwjALm03d7vdWLLOexAK9uSffZhofMRdGczvZVEOepHcDH1RSBhZf13Z58wqt0kGcJc-g/exec

const QuoteModal = ({ product, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    quantity: "",
  });

  const [status, setStatus] = useState("");

  if (!product) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    const body =
      "name=" + encodeURIComponent(formData.name) +
      "&phone=" + encodeURIComponent(formData.phone) +
      "&product=" + encodeURIComponent(product.name) +
      "&price=" + encodeURIComponent(product.price || "") +
      "&quantity=" + encodeURIComponent(formData.quantity);

    fetch(WEB_APP_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body,
    })
      .then(() => {
        setStatus("Quote request sent successfully!");
        setTimeout(() => {
          setFormData({ name: "", phone: "", quantity: "" });
          onClose();
        }, 1200);
      })
      .catch(() => {
        setStatus("Failed to send request.");
      });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <h3>Request a Quote</h3>
        <h4>{product.name}</h4>

        <form className="modal-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
          />

          <input
            type="tel"
            placeholder="Your Contact Number"
            required
            value={formData.phone}
            onChange={(e) =>
              setFormData({ ...formData, phone: e.target.value })
            }
          />

          <input
            type="text"
            placeholder="Required Quantity"
            required
            value={formData.quantity}
            onChange={(e) =>
              setFormData({ ...formData, quantity: e.target.value })
            }
          />

          <button type="submit" className="submit-button">
            Submit Request
          </button>

          {status && <p className="form-status">{status}</p>}
        </form>
      </div>
    </div>
  );
};

export default QuoteModal;